// Section name constants — equivalent to backend's InterfaceSectionNames.
// Each value must match the sectionName string sent by the API in menu permissions.

export const SECTIONS = {
  GENERAL: 'General',
  AREAS: 'Areas',
  CARGOS: 'Cargos',
  CENTROS_COSTO: 'Centro de costos',
  TURNOS_ROTATIVOS_Y_FIJOS: 'TURNOS_ROTATIVOS_Y_FIJOS',
  PERMISOS_APP_MOVIL: 'Permisos APP Móvil',
} as const;

export type SectionName = typeof SECTIONS[keyof typeof SECTIONS];
